import { render, staticRenderFns } from "./VIPLevel.vue?vue&type=template&id=5c2f69e9&"
import script from "./VIPLevel.vue?vue&type=script&lang=js&"
export * from "./VIPLevel.vue?vue&type=script&lang=js&"
import style0 from "./VIPLevel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports